<script>
import { OneCareService } from '@/api/OneCareService';
import Vue from 'vue';

export default {
  data: function () {
    return {
      showReportPdfOptionsModal: false,
      reportActionType: null,
      downloadPdfReportLoading: false,
      selectedAppointmentId: null
    }
  },
  methods: {
    handleShowPdfReportOptionsModal(type, appointmentId = null) {
      this.reportActionType=type
      this.showReportPdfOptionsModal=true
      if(appointmentId) {
        this.selectedAppointmentId = appointmentId
      }
    },
    reportPdfOptionsModalConfirmation(data) {
      this.showReportPdfOptionsModal = false
      this.reportActionType = null
      if(data.filters.actionType && data.filters.actionType === 'download') {
        this.handleDownloadPdfReport(data.filters.dates.start, data.filters.dates.end, data.filters.maxRecords)
      } else if (data.filters.actionType && data.filters.actionType === 'email') {
        this.sendPdfByEmail(data.filters.dates.start, data.filters.dates.end, data.filters.maxRecords)
      }

    },
    async handleDownloadPdfReport(start, end, maxRecords) {
      //OLD CODE
      //this.$router.push({name: `check-up_plus/checkup_plus/patients/id/report`, params: {id: this.patientDetails.idPerson}})
      this.downloadPdfReportLoading = true;

      let patientId = null
      //since its a mixin and we dont know where it is used we must check for every possibility
      if(this.patientDetails) {
        patientId = this.patientDetails.idPerson
      } else if (this.patient) {
        patientId = this.patient.oneCarePersonId
      }

      try {
        let language = this.$i18n.locale()
        if(language === 'gb') language = 'en'
        let data = await OneCareService.getReportData(patientId, language, start, end, maxRecords, this.selectedAppointmentId)

        /*?let parsedData = { }
        parsedData.patientDetails = {
          patientName: data.headerInformation.patientName,
          date: moment.utc(data.headerInformation.appointmentDate).local().format('DD/MM/YYYY'),
          gender: data.headerInformation.sex,
          nationality: data.headerInformation.nationality,
          birthdate: moment(data.headerInformation.dateOfBirth).format('DD/MM/YYYY'),
          address: data.headerInformation.patientAddress,
          facility: data.headerInformation.facilityName,
          facilityId: data.headerInformation.facilityId,
          entity: data.headerInformation.entityName,
          entityId: data.headerInformation.entityId
        }
        parsedData.overallSummary = {
          recommendation: data.overallSummary.recommendation,
          results: []
        }
        data.overallSummary.overallSummaryResults.forEach(elem => {
          parsedData.overallSummary.results.push({
            slug: elem.classificationSlug,
            currentNormal: elem.currentNormal,
            currentNotNormal: elem.currentNotNormal,
            previousNormal: elem.previousNormal,
            previousNotNormal: elem.previousNotNormal,
            totalParameters: elem.totalParameters
          })
        })

        parsedData.resultsByGroupClassification = data.resultsByGroupClassification
        parsedData.overallReferenceValues = data.overallReferenceValues
        parsedData.overallReferenceValues.forEach(elem => {
          elem.referenceTable = this.$t(`dashboard_new_evollu.parameters.graphs.titles.${elem.referenceTable.toLowerCase()}`)
        })

        parsedData.historicalData = data.historicalData
        //Parse audiology historical data because some info is not necessary
        parsedData.historicalData.forEach(elem => {
          if (elem.groupName === 'Audiologia') {
            elem.headers[1] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 500 Hz'
            elem.headers[2] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 1000 Hz'
            elem.headers[3] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 2000 Hz'
            elem.headers[4] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 4000 Hz'
            elem.headers[5] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 6000 Hz'
            elem.headers[6] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 5000 Hz'
            elem.headers[7] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 1000 Hz'
            elem.headers[8] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 2000 Hz'
            elem.headers[9] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 4000 Hz'
            elem.headers[10] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 6000 Hz'
            elem.headers.splice(11, 2)
            elem.headers.splice(12, 2)
            elem.headers.splice(13, 2)
            elem.headers.splice(13, 6)

            elem.historyData.forEach(data => {
              data.data.splice(11, 2)
              data.data.splice(12, 2)
              data.data.splice(13, 2)
              data.data.splice(13, 6)
            })
          }
        }) */

        this.isLoading = false
        //const finalData = await this.parseDataForJsReport(parsedData)

        //request the report
        try {
          //process.env.VUE_APP_REPORTER_URL
          const response = await Vue.axios.post(process.env.VUE_APP_REPORTER_URL, JSON.stringify(data), {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf',
                'Authorization': `Basic ${process.env.VUE_APP_REPORTER_TOKEN}`
              },
              responseType: 'blob'
            }
          );

          // Create a URL for the blob and download the file
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          //link.download = data.headerInformation.patientName ? `relatório_${data.headerInformation.patientName.toLowerCase().replace(/ /g, "_")}.pdf` : 'relatório.pdf';
          link.download = data.data && data.data.patientDetails && data.data.patientDetails.patientName ? `relatório_${data.data.patientDetails.patientName.toLowerCase().replace(/ /g, "_")}.pdf` : 'relatório.pdf';
          link.click();

          // Clean up by revoking the blob URL
          URL.revokeObjectURL(link.href);
        } catch (error) {
          console.error('Error downloading the PDF:', error);
        } finally {
          this.downloadPdfReportLoading = false
          this.selectedAppointmentId = null
        }


      } catch (err) {
        this.downloadPdfReportLoading = false
        console.log(err)
      }
    },
    sendPdfByEmail: async function (start, end, maxRecords) {
      let patientId = null
      //since its a mixin and we dont know where it is used we must check for every possibility
      if(this.patientDetails) {
        patientId = this.patientDetails.idPerson
      } else if (this.patient) {
        patientId = this.patient.oneCarePersonId
      }

      let patientEmail = null
      if(this.patientDetails) {
        patientEmail = this.patientDetails.email
      } else if (this.patient) {
        patientEmail = this.patient.email
      }

      try {
        this.isSendingPdf = true
        await OneCareService.sendPdfByEmail(patientId, patientEmail, this.$i18n.locale(), start, end, maxRecords, this.selectedAppointmentId)
        this.showToast(this.$t('dashboard_new_evollu.pdf_sent_successfully'), this.$store.state.successToastOptions)
        this.isSendingPdf = false
      } catch (e) {
        console.log(e)
        this.isSendingPdf = false
        this.showToast(this.$t('dashboard_new_evollu.pdf_not_sent'), this.$store.state.errorToastOptions)
      }
    },
  }
}
</script>
